module.exports = __webpack_public_path__ + "media/club_deals/why_invest_in_club_deals-7d41033c.webp";